import { Grid, styled, Paper, Typography, Rating, Box, IconButton, Link } from "@mui/material";
import { Container, fontSize } from "@mui/system";
import React, { useState, useEffect } from "react";
import globals from "../globals";
import SchoolIcon from '@mui/icons-material/School';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import CourseCarousel from "../components/carousels/courseCarousel";
import { useParams, useNavigate } from "react-router-dom";

import LoadingPage from "../error_page/loadingPage";

const InstructorPage = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [instructor, setInstructor] = useState(null);
    const [loading, setLoading] = useState(true);

    //console.log(id);

    useEffect(() => {
        fetch(`${globals.apiUrl}/auth/instructor/${id}`)
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
                if (response.status === 404) {
                    navigate('/not-found');
                }
            })
            .then(data => {
                setInstructor(data);
                setLoading(false);
            })
            .catch(error => {
                navigate('/not-found');
            });
    }, [id]);

    const [ratingValue, setRatingValue] = useState(5)

    const education = [
        "International Career Institute, Diploma in Hospitality & Hotel Management", "CIPD Qualifications, Professional Diploma in HR Practice (CIPD)", "Sofia University St. Kliment Ohridski, Bachelor of Arts (B.A.), Psychology"
    ]

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: globals.colors.lightGray,
        ...theme.typography.body2,
        padding: theme.spacing(3),
        textAlign: 'center',
        color: globals.colors.textColor,
        ...theme.applyStyles('dark', {
            backgroundColor: globals.colors.textColor,
        }),
    }));


    return (
        loading ? <LoadingPage /> :
            <Container>
                <Grid container sx={{ justifyContent: 'space-evenly', mt: 5 }} spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Item>
                            <img src={(instructor.image_url) ? instructor.image_url : '/noone.webp'} height={250} width={250} style={{ borderRadius: 10 }} />
                            <Typography variant="h5"><strong>{instructor.first_name + " " + instructor.last_name}</strong></Typography>
                            <Typography variant="h6" textTransform={'capitalize'} textAlign='left' sx={{ mt: 2 }}><SchoolIcon sx={{ mr: 1, mb: -0.6 }} /><strong>Образование:</strong></Typography>
                            <Typography variant="body1" textAlign='left' sx={{ mt: 2 }} dangerouslySetInnerHTML={{ __html: instructor.education ? instructor.education : "Учителят не е добавил повече информация." }}></Typography>
                            {/* <ul style={{ fontSize: 20, textAlign: 'left' }}>
                            {education.map((educationPoint, i) => {
                                return <li style={{ paddingTop: 10 }} key={i}>{educationPoint}</li>
                            })}
                        </ul> */}
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Grid container direction='row' justifyContent={'left'}>
                            <Typography variant="body2" textTransform={'uppercase'} color={globals.colors.gray} sx={{ ml: 5 }}><strong>{`${instructor.courses.length} ${instructor.courses.length === 1 ? "курс" : "курса"}`}</strong></Typography>
                            {/* <Rating
                                sx={{ ml: 10 }}
                                name="simple-controlled"
                                value={ratingValue}
                                onChange={(event, newValue) => {
                                    setRatingValue(newValue);
                                }}
                            /> */}
                        </Grid>
                        <Typography variant="h3" sx={{ mt: 10, ml: 5, mb: 3 }} color={globals.colors.lightRed}><strong>{instructor.first_name + " " + instructor.last_name}</strong></Typography>
                        {/* <Grid container direction={'row'}>
                            <Link href='#'>
                                <Box sx={{ height: 40, width: 40, backgroundColor: globals.colors.gray, borderRadius: 1, ml: 5 }}  >
                                    <LinkedInIcon sx={{ height: 40, width: 40, color: globals.colors.lightGray }} />
                                </Box>
                            </Link>
                            <Link href='/#'>
                                <Box sx={{ height: 40, width: 40, backgroundColor: globals.colors.gray, borderRadius: 1, ml: 2 }}  >
                                    <FacebookIcon sx={{ height: 40, width: 40, color: globals.colors.lightGray }} />
                                </Box>
                            </Link>
                            <Link href='/#'>
                                <Box sx={{ height: 40, width: 40, backgroundColor: globals.colors.gray, borderRadius: 1, ml: 2 }}  >
                                    <InstagramIcon sx={{ height: 40, width: 40, color: globals.colors.lightGray }} />
                                </Box>
                            </Link>
                        </Grid> */}
                        <Typography variant="h5" sx={{ mt: 5, ml: 5 }}><strong>Биография</strong></Typography>
                        <Typography variant="body1" sx={{ mt: 2, ml: 5 }} dangerouslySetInnerHTML={{
                            __html: instructor.description ? instructor.description : "В момента учителят не е добавил своята биография. Очаквайте скоро!"
                        }}></Typography>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'} sx={{ mt: 10 }} textAlign={'center'}>
                    <Grid item sx={12} xs={12}>
                        <Typography variant="h6" sx={{color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 30, mb:2}}>Курсове на учителя</Typography>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        {instructor.courses.length > 0 ?
                            <CourseCarousel courses={instructor.courses} />
                            : <Typography>Учителят няма създадени курсове.</Typography>
                        }
                    </Grid>
                </Grid>
            </Container>
    )
}

export default InstructorPage